/* ============================================================
   SOLARA PRODUCT ADD-ONS
   Compact rows under the buy button: each add-on has its own Add button.
   Cards near the bottom: tick what you want, add the selection in one go.
   Uses the same cart flow as the theme's product forms, so the cart drawer
   and cart count update exactly as they do for the main Add to cart button.
   Safe to load more than once.
   ============================================================ */
(function () {
  if (window.SolaraAddons) {
    window.SolaraAddons.scan(document);
    return;
  }

  var hasTheme = function () {
    return window.theme && theme.routes && theme.utils && theme.pubsub;
  };

  var money = function (cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0
      ? d.toLocaleString('en-AU')
      : d.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  /* Add items to the cart. Resolves on success, rejects with a message. */
  var addItems = function (items, trigger, openDrawer) {
    if (!hasTheme()) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
          window.location.href = '/cart';
          return d;
        });
      });
    }

    if (document.body.classList.contains('template-cart') || (theme.settings && theme.settings.cartType === 'page')) {
      theme.utils.postLink2(theme.routes.cart_add_url, { parameters: { items: items } });
      return Promise.resolve();
    }

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var config = theme.utils.fetchConfig('javascript');
    config.body = JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname });

    return fetch(theme.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (state) {
        return fetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET'))
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (state.status) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'solara-addons', cart: cart });
              throw new Error(state.description || state.message || 'Could not add to cart.');
            }
            cart.sections = state.sections;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'solara-addons', cart: cart });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
            var drawer = document.querySelector('cart-drawer');
            if (openDrawer && drawer && typeof drawer.show === 'function') {
              drawer.show(trigger && trigger.isConnected ? trigger : null);
            } else if (!drawer) {
              window.location.href = theme.routes.cart_url;
            }
            return state;
          });
      });
  };


  /* ---- Live stock -------------------------------------------------
     Pages can be cached briefly, so each add-on's stock is re-checked
     from Shopify when the page loads. Sold-out items stay visible,
     crossed out and tagged, and can't be added. */
  var productCache = {};
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fetchProduct = function (handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(rootUrl + 'products/' + handle + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  };

  var setSoldOut = function (item, sold) {
    var wasSold = item.classList.contains('is-soldout');
    item.classList.toggle('is-soldout', sold);
    var tag = item.querySelector('[data-sao-oos]');
    if (tag) tag.hidden = !sold;
    var btn = item.querySelector('[data-sao-add]');
    if (btn) btn.disabled = sold;
    var cb = item.querySelector('[data-sao-check]');
    if (cb) {
      cb.disabled = sold;
      if (sold) cb.checked = false;
      else if (wasSold) cb.checked = true;
    }
  };

  var checkStock = function (root) {
    var items = root.querySelectorAll('[data-sao-item][data-handle]');
    var jobs = Array.prototype.map.call(items, function (item) {
      return fetchProduct(item.getAttribute('data-handle')).then(function (p) {
        if (!p || !p.variants) return;
        var vid = Number(item.getAttribute('data-variant-id'));
        var v = p.variants.filter(function (x) { return x.id === vid; })[0];
        var sel = item.querySelector('[data-sao-variant]');
        if ((!v || !v.available) && !item.hasAttribute('data-sao-main')) {
          var alt = p.variants.filter(function (x) { return x.available; })[0];
          if (alt) {
            v = alt;
            item.setAttribute('data-variant-id', alt.id);
            item.setAttribute('data-price', alt.price);
            var price = item.querySelector('[data-sao-price]');
            if (price) price.textContent = money(alt.price);
            if (sel) sel.value = String(alt.id);
          }
        }
        if (sel) {
          Array.prototype.forEach.call(sel.options, function (o) {
            var ov = p.variants.filter(function (x) { return String(x.id) === o.value; })[0];
            if (ov) o.disabled = !ov.available;
          });
        }
        setSoldOut(item, !(v && v.available));
      });
    });
    return Promise.all(jobs).then(function () { root.dispatchEvent(new CustomEvent('sao:change')); });
  };

  /* Variant pickers keep each item's variant id and price in sync */
  var bindVariants = function (root) {
    root.querySelectorAll('[data-sao-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var item = sel.closest('[data-sao-item]');
        var opt = sel.options[sel.selectedIndex];
        if (!item || !opt) return;
        item.setAttribute('data-variant-id', opt.value);
        item.setAttribute('data-price', opt.getAttribute('data-price'));
        var price = item.querySelector('[data-sao-price]');
        if (price) price.textContent = money(Number(opt.getAttribute('data-price')));
        var handle = item.getAttribute('data-handle');
        if (handle) {
          fetchProduct(handle).then(function (p) {
            var v = p && p.variants && p.variants.filter(function (x) { return String(x.id) === opt.value; })[0];
            setSoldOut(item, v ? !v.available : opt.disabled);
            root.dispatchEvent(new CustomEvent('sao:change'));
          });
        }
        root.dispatchEvent(new CustomEvent('sao:change'));
      });
    });
  };

  var setLabel = function (btn, text) {
    var label = btn.querySelector('[data-sao-label]');
    if (label) label.textContent = text;
  };

  var say = function (root, text, isError) {
    var msg = root.querySelector('[data-sao-msg]');
    if (!msg) return;
    msg.textContent = text || '\u00a0';
    msg.classList.toggle('is-error', !!isError);
  };

  var setupCompact = function (root) {
    var openDrawer = root.hasAttribute('data-sao-open-drawer');
    bindVariants(root);
    /* Cart rows are re-rendered by Shopify on every cart change, so stock is already fresh there */
    if (!root.classList.contains('sao--cart')) checkStock(root);
    root.querySelectorAll('[data-sao-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        var item = btn.closest('[data-sao-item]');
        var id = Number(item && item.getAttribute('data-variant-id'));
        if (!id) return;
        btn.setAttribute('aria-busy', 'true');
        setLabel(btn, 'Adding');
        say(root, '');
        addItems([{ id: id, quantity: 1 }], btn, openDrawer)
          .then(function () {
            btn.classList.add('is-added');
            setLabel(btn, 'Added');
            var title = item.querySelector('.sao-row__title');
            say(root, (title ? title.textContent.trim() : 'Item') + ' added to your cart.');
            setTimeout(function () {
              btn.classList.remove('is-added');
              setLabel(btn, 'Add');
            }, 2500);
          })
          .catch(function (err) {
            setLabel(btn, 'Add');
            say(root, err.message, true);
            productCache[item.getAttribute('data-handle')] = null;
            checkStock(root);
          })
          .then(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  };

  var setupCards = function (root) {
    var openDrawer = root.hasAttribute('data-sao-open-drawer');
    var btn = root.querySelector('[data-sao-add-selected]');
    var defaultLabel = btn ? (btn.querySelector('[data-sao-label]') || btn).textContent.trim() : '';
    bindVariants(root);

    var selected = function () {
      return Array.prototype.filter.call(root.querySelectorAll('[data-sao-item]'), function (item) {
        var cb = item.querySelector('[data-sao-check]');
        if (item.classList.contains('is-soldout')) return false;
        return !cb || cb.checked;
      });
    };
    var refresh = function () {
      var items = selected();
      var total = items.reduce(function (sum, item) { return sum + Number(item.getAttribute('data-price') || 0); }, 0);
      var count = root.querySelector('[data-sao-count]');
      var word = root.querySelector('[data-sao-count-word]');
      var totalEl = root.querySelector('[data-sao-total]');
      if (count) count.textContent = String(items.length);
      if (word) word.textContent = items.length === 1 ? 'item' : 'items';
      if (totalEl) totalEl.textContent = money(total);
      root.querySelectorAll('[data-sao-item]').forEach(function (item) {
        var cb = item.querySelector('[data-sao-check]');
        item.classList.toggle('is-off', !!cb && !cb.checked);
      });
      if (btn) btn.disabled = items.length === 0;
    };

    root.querySelectorAll('[data-sao-check]').forEach(function (cb) {
      cb.addEventListener('change', refresh);
    });
    root.addEventListener('sao:change', refresh);
    checkStock(root);

    /* Keep the "This item" card on the variant chosen in the buy box */
    var main = root.querySelector('[data-sao-main]');
    if (main && hasTheme() && theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        var v = data && data.variant;
        if (!v || String(data.productId) !== root.getAttribute('data-product-id')) return;
        main.setAttribute('data-variant-id', v.id);
        main.setAttribute('data-price', v.price);
        var price = main.querySelector('[data-sao-price]');
        if (price) price.textContent = money(v.price);
        setSoldOut(main, !v.available);
        refresh();
      });
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var items = selected().map(function (item) {
          return { id: Number(item.getAttribute('data-variant-id')), quantity: 1 };
        }).filter(function (i) { return i.id; });
        if (!items.length || btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        setLabel(btn, 'Adding to cart');
        say(root, '');
        addItems(items, btn, openDrawer)
          .then(function () {
            setLabel(btn, 'Added to cart');
            say(root, items.length === 1 ? '1 item added to your cart.' : items.length + ' items added to your cart.');
            setTimeout(function () { setLabel(btn, defaultLabel); }, 2500);
          })
          .catch(function (err) {
            setLabel(btn, defaultLabel);
            say(root, err.message, true);
          })
          .then(function () {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
            refresh();
          });
      });
    }
    refresh();
  };

  var scan = function (scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-sao]').forEach(function (root) {
      if (root.__sao) return;
      root.__sao = true;
      if (root.getAttribute('data-sao-layout') === 'cards') {
        setupCards(root);
      } else {
        setupCompact(root);
      }
    });
  };

  window.SolaraAddons = { scan: scan, addItems: addItems };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
